import { getISODay } from "date-fns";
export function isStoreOpen(hours) {
  let date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  const currentDow = getISODay(date);
  const todayHours = (hours === null || hours === void 0 ? void 0 : hours[currentDow]) || [];
  if (todayHours.length === 0) return false;
  return todayHours.some(interval => {
    const [openHour, openMinute] = interval.open.split(':').map(Number);
    const [closeHour, closeMinute] = interval.close.split(':').map(Number);
    const openTime = new Date(date);
    openTime.setHours(openHour, openMinute, 0);
    const closeTime = new Date(date);
    closeTime.setHours(closeHour, closeMinute, 0);
    return date >= openTime && date < closeTime;
  });
}
export function getStoreStatus(hours) {
  const now = new Date();
  const today = getISODay(now);
  const tomorrow = today === 7 ? 1 : today + 1; //tomorrow is Monday if today is Sunday

  const todayHours = (hours === null || hours === void 0 ? void 0 : hours[today]) || [];
  const tomorrowHours = (hours === null || hours === void 0 ? void 0 : hours[tomorrow]) || [];
  const isOpen = todayHours.length > 0 && isStoreOpen(hours, now);
  return {
    isOpen: isOpen,
    todayHours: todayHours,
    tomorrowHours: tomorrowHours
  };
}